
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/volumi/[slug]",
      function () {
        return require("private-next-pages/volumi/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/volumi/[slug]"])
      });
    }
  